//import * as HG from './assets/highways.js';
import $ from 'jquery';
import L from 'leaflet';
import axios from 'axios';
import styleSelect from 'styleselect';

const jsrender = require('jsrender')($);

$(document).ready(function () {

  const $discountsMap = $('.m-discounts-map');


  if ($discountsMap.length > 0) {


    /**########## INIT PAGE SECTION ########### */

    const selectorsData = {};

    // Map vars
    let lastLayerClicked = null;
    const layers = [];
    const osmUrl = 'https://tile.openstreetmap.org/{z}/{x}/{y}.png';
    const osmAttribution = 'OpenStreetMap - Pagatelia S.L.U.';
    const osmLayer = new L.TileLayer(osmUrl, { maxZoom: 15, attribution: osmAttribution });

    const lat = 40.446947;
    const lon = -3.669434;
    const latlng = new L.LatLng(lat, lon);

    const map = new L.Map('map', { center: latlng, zoom: 5, layers: [osmLayer], scrollWheelZoom: false });
    const styleNormal = { 'color': '#7C1780', 'weight': 8, 'opacity': 0.5 };
    const styleSelected = { 'color': '#1A35FE', 'weight': 8, 'opacity': 0.75 };


    const HG = [];

    //Call functions to load all elements
    LoadData();    

    /**########## END INIT PAGE SECTION ########### */

    /**########## SELECTORS SECTION ############ */   
       
    //Load selectors data from database
    function LoadData() {
      const requests = [];
      const query = [];
      query.push({ name: 'communities', url: '/common/discounts/communities' });
      query.push({ name: 'highways', url: '/common/discounts/highways' });

      query.forEach(q => requests.push(
        axios.get(q.url).then(function (response) {
          selectorsData[q.name] = response.data.data;
        })
      ));

      axios.all(requests).then(function (results) {
        LoadPage();
      });
    }

    //Load selectors styles and events
    function LoadPage() {
      LoadCommunitiesSelector();
      LoadHighwaysSelector();
      $("#dataLoadingSpinner").remove();
      LoadHighwaysGeo();
      LoadDiscountFromUrl();
    }

    //Load communities selector    
    function LoadCommunitiesSelector() {      
      const communitiesDDTmpl = jsrender.templates('#communitiesDDTmpl');
      const $discountsRegion = $('.discounts-region');
      const html = communitiesDDTmpl.render(selectorsData);
      $discountsRegion.html(html);

      RefreshSelectStyles($discountsRegion);
      AddOnCommunityChangeEvent();

    }

    //Load highways selector
    function LoadHighwaysSelector() {
      const highwaysDDTmpl = jsrender.templates('#highwaysDDTmpl');
      const $discountsHighways = $('.discounts-highways');
      const html = highwaysDDTmpl.render(selectorsData);
      $discountsHighways.html(html);

      RefreshSelectStyles($discountsHighways);
      AddOnHighwayChangeEvent();
    }

    //Load discounts list 
    function LoadDiscountSection(data) {
      const discountsTmpl = jsrender.templates('#discountsTmpl');
      const $discountsList = $('.discounts-list');
      data.discountGroups.forEach(function (dg) {
        dg.discounts = dg.discounts.sort((a, b) => (a.title > b.title) ? 1 : -1);
      })
      const html = discountsTmpl.render(data);

      $discountsList.html(html);
      AddOnDiscountViewInMapClick();
    }

    //Refresh SelectStyles
    function RefreshSelectStyles($select) {
      $select.each(function () {
        const $thisSelect = $(this);
        const $innerSelects = $thisSelect.find('select');

        $innerSelects.each(function () {
          const select = $(this)[0];
          styleSelect(select);
        });
      });
    }

    //Add onchange event to communitites selector
    function AddOnCommunityChangeEvent() {
      const $communitiesSelect = $('.discounts-region').find('select');
      $communitiesSelect.on('change', (event) => {
        ResetMapView();
        const selectedValue = $communitiesSelect.find('option:selected').val();
        const community = selectorsData.communities.find(c => c.communityId == selectedValue);
        if (community == undefined) {
          ResetDiscountSection();
        } else {
          SetHighwaySelection('-1');
          LoadDiscountSection(community);
        }        
      });
    }

    //Add onchange event to highways selector
    function AddOnHighwayChangeEvent() {
      const $highwaysSelect = $('.discounts-highways').find('select');
      $highwaysSelect.on('change', (event) => {
        ResetMapView();
        const selectedValue = $highwaysSelect.find('option:selected').val();
        const highway = selectorsData.highways.find(h => h.highwayId== selectedValue);
        if (highway == undefined) {
          ResetDiscountSection();
        } else {
          SetCommunitySelection('-1');
          LoadDiscountSection(highway);
        }
      });
    }

    //Add onclick event to link
    function AddOnDiscountViewInMapClick(){
      const $discounts = $('.map-link');
      $discounts.each(function () {
        const $link = $(this);
        $link.click(function () {
          const discountId = $link.attr('id');
          SetDiscountMapLayer(discountId);
          GoToByScroll("map");
        });
      });
      
    }

    //reset discount section
    function ResetDiscountSection() {
      var emptyDiscounts = {};
      emptyDiscounts.discountGroups = [];
      LoadDiscountSection(emptyDiscounts);
    }

    //reset communities section
    function SetCommunitySelection(selectedValue) {         
      if (selectorsData.communities != undefined) {
        selectorsData.communities.forEach(function (community) {
          if (community.communityId == selectedValue) {
            community.isSelected = true;
          } else {
            community.isSelected = false;
          }
        });

      }
      LoadCommunitiesSelector();
    }

    //reset highways section
    function SetHighwaySelection(selectedValue) {
      if (selectorsData.highways != undefined) {
        selectorsData.highways.forEach(function (highway) {
          if (highway.highwayId == selectedValue) {
            highway.isSelected = true;
          } else {
            highway.isSelected = false;
          }
        });
      }
      LoadHighwaysSelector();
    }

    //set map view
    function SetDiscountMapLayer(discountId) {
      //ResetMapView();
      for (var index = 0; index < layers.length; index++) {
        if (layers[index].properties.id == discountId) {
          ChangeLayer(layers[index], null);
        }
      }   
    
    }

    function GoToByScroll(id) {
      // Remove "link" from the ID
      id = id.replace("link", "");
      // Scroll
      $('html,body').animate({
        scrollTop: $("#" + id).offset().top - 50
      }, 'slow');
    }

    /**########## END SELECTORS SECTION ############ */


     /**########## MAP SECTION ############ */    
   
    function ResetMapView() {

      if (lastLayerClicked) {
        lastLayerClicked.setStyle(styleNormal);
      }

      const lat = 40.446947;
      const lon = -3.669434;
      const latlng = new L.LatLng(lat, lon);
      map.setView(latlng, 5);
    }   

    // Map helpers
    function ClickLayer(e) {
      ChangeLayer(e.target, e);
    } 

    function ChangeLayer(layer, e) {
      map.fitBounds(layer.getBounds());

      if (lastLayerClicked) {
        lastLayerClicked.setStyle(styleNormal);
      }

      lastLayerClicked = layer;
      layer.setStyle(styleSelected);
      layer.bringToFront();
      
      if (e) {
        const popup = L.popup()
          .setLatLng(e.latlng)
          .setContent('<p>' + layer.feature.properties.Name + '</p>')
          .openOn(map);
      }
    }

    function MouseOver(e) {
      const layer = e.target;
      if (!L.Browser.ie && !L.Browser.opera) {
        layer.bringToFront();
      }
    }

    function OnEachFeature(feature, layer) {
      layer.on({
        mouseover: MouseOver,
        click: ClickLayer
      });
    }


    function LoadHighwaysGeo() {

      selectorsData.communities.forEach(function (c) {
        c.discountGroups.forEach(function (dg) {
          dg.discounts.forEach(function (d) {
            var highwayGeoJSON = {};
            highwayGeoJSON.type = "Feature";
            highwayGeoJSON.properties = { id: d.discountId, Name: d.highway.code + " - " + d.stretch };
            highwayGeoJSON.geometry = { type: "LineString", coordinates: JSON.parse(d.stretchCoordinates) };
            HG.push(highwayGeoJSON);
          });
        });
      });

      // Add layers
      HG.forEach(function (hg) {
        var layer = L.geoJson(hg, {
          style: styleNormal,
          onEachFeature: OnEachFeature
        });
        layer.properties = hg.properties;
        layers.push(layer.addTo(map));
      });
    }

     /**########## END MAP SECTION ############ */

    /**########## URL GET DISCOUNT SECTION ############ */
    function LoadDiscountFromUrl() {
      var parameter = GetUrlParameter();
      if (parameter != undefined && parameter != "") {
        var community = selectorsData.communities.find(c => c.seoName.toLowerCase() == parameter.toLowerCase());
        var highway = selectorsData.highways.find(h => h.seoName.toLowerCase() == parameter.toLowerCase());
        if (community != undefined) {
          SetCommunitySelection(community.communityId);
          LoadDiscountSection(community);
        } else if (highway != undefined) {
          SetHighwaySelection(highway.highwayId);
          LoadDiscountSection(highway);
        }
      }
    }

    function GetUrlParameter() {
      var url = window.location.pathname;

      //eliminamos el idioma
      var cultures = ["es/", "en/", "it/", "/fr/", "/de/"];
      cultures.forEach(function (culture) {
        if (url.indexOf("/" + culture) != -1) {
          url = url.replace(culture, "");
        }
      });

      var parameter = "";
      //eliminamos la ruta de la página de descuentos
      parameter = url.substring(url.indexOf("/") + 1);
      parameter = parameter.substring(parameter.indexOf("/") + 1);
      //modificacmos los caracteres especiales
      if (parameter != undefined) {
        parameter = parameter.replace(new RegExp("%20", 'g'), " ");
        parameter = parameter.replace(new RegExp("%C3%AD", 'g'), "í");
        parameter = parameter.replace(new RegExp("%C3%B3", 'g'), "ó");
        parameter = parameter.replace(new RegExp("%C3%A1", 'g'), "á");
        parameter = parameter.replace(new RegExp("%C3%A9", 'g'), "é");
        parameter = parameter.replace(new RegExp("%C3%BA", 'g'), "ú");
        parameter = parameter.replace(new RegExp("%C3%B1", 'g'), "ñ");
      }


      return parameter;
    }
    /**########## END URL GET DISCOUNT SECTION ############ */
    
  }
}); 



// WEBPACK FOOTER //
// ./app/ui/modules/discounts-map/index.js